import { render } from "./QuestionFeedbackList.vue?vue&type=template&id=95c32276&scoped=true"
import script from "./QuestionFeedbackList.vue?vue&type=script&lang=js"
export * from "./QuestionFeedbackList.vue?vue&type=script&lang=js"

import "./QuestionFeedbackList.vue?vue&type=style&index=0&id=95c32276&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95c32276"]])

export default __exports__